import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Spinner } from "react-bootstrap";

import { fetchTermsOfUse } from "../../redux/slice/termsOfUse/termsOfUse";

import "./terms.scss";
import Header from "../../component/header/Header";
import Aside from "../../component/aside/Aside";
import Footer from "../../component/footer/Footer2";
import { useLocalizes } from "../../utils/useLocalizes";

const Terms = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("v-pills-home");
  const { termsData, loading } = useSelector((state) => state.termsOfUse);
  const htmlString = termsData?.[0]?.attributes?.Terms_Of_Use;
  const { 
    loading: localizesLoading, 
    error: localizesError, 
    getLocalizedValue
  } = useLocalizes();

  const tncDate = getLocalizedValue("dlf_tnc_date", "Updated 05 August, 2025");
  useEffect(() => {
    dispatch(fetchTermsOfUse());
    // eslint-disable-next-line
  }, []);

  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      onClick={() => navigate("/home")}
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#1D1D1B",
      }}
    >
      Home
    </Link>,
    <Typography
      key="3"
      sx={{
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "15px",
        color: "#1D1D1B",
      }}
    >
      Terms And Conditions
    </Typography>,
  ];
  const breadcrumbsMobile = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      onClick={() => navigate("/home")}
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#A9A9A9",
      }}
    >
      Home
    </Link>,
    <Typography
      key="3"
      sx={{
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "15px",
        color: "#ffffff",
      }}
    >
      Terms And Conditions
    </Typography>,
  ];

  return (
    <>
      <Header activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className="home">
        <div
          className="container pt-5 in-mobile desktop_content"
          style={{ paddingBottom: "40px" }}
        >
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            {breadcrumbs}
          </Breadcrumbs>
        </div>
        <div className="sidebar">
          <div className="container">
            <div className="row">
              <div className="col-lg-4  col-md-4 desktop_content">
                <Aside activeTab={activeTab} setActiveTab={setActiveTab} />
              </div>
              <div className="col-lg-8 col-md-8 in-mobile">
                <div className="tabs">
                  <div className="tab_content">
                    <div className="tab-content" id="v-pills-tabContent">
                      <div
                        className=""
                        id="v-pills-offers"
                        role="tabpanel"
                        aria-labelledby="v-pills-offers-tab"
                        tabIndex="0"
                      >
                        <div className="container1">
                          <div className="title-container">
                            <div className="container pt-5 in-mobile mobile_content">
                              <Breadcrumbs
                                separator={
                                  <NavigateNextIcon
                                    fontSize="small"
                                    sx={{ color: "#A9A9A9" }}
                                  />
                                }
                                aria-label="breadcrumb"
                              >
                                {breadcrumbsMobile}
                              </Breadcrumbs>
                            </div>
                            <p className="redtext">{tncDate}</p>
                            <h1 className="privacytext">Terms & Conditions</h1>
                          </div>
                            {loading && termsData?.length === 0 ? (
                              <div className="spinner_table_height">
                                <Spinner color="black" />
                              </div>
                            ) : (                              
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: htmlString,
                                  }}
                                  className="tNc"
                                />                              
                            )}                    
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footerMobPending"></div>
      <Footer selected="home" />
    </>
  );
};

export default Terms;
